<template>
    <div>
        <div class="loader" v-if="!loaded">
            <div>Loading</div>
            <div>{{dots}}</div>
        </div>
        <div v-if="loaded">
            <slot></slot>
        </div>
    </div>

</template>

<script>
    let changeDots;
    export default {
        name: "LoaderSplash",
        props: ['loaded'],
        data(){
            return{
                dots_count:1,
            }
        },
        computed:{
            dots(){
                return ".".repeat(this.dots_count);
            }

        },
        mounted(){
            changeDots = setInterval(()=>{
                if(this.dots_count >= 10){
                    this.dots_count = 1;
                }else{
                    this.dots_count ++;
                }
            }, 200);

        },
        watch:{
            loaded(newVal,oldVal){
                if(newVal){
                    clearTimeout(changeDots)
                }
            }
        }


    }
</script>

<style scoped>
    .loader{
        height: calc(100vh - 150px);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

    }
    .loader div{
        font-size: 2rem;
        text-align: center;
        line-height: 0.5;
    }
</style>